<template>
  <div id="app">
    <header class="app-header text-right fixed-top" ref="app-header">
      <a href="/" class="app-header__volver">
        &laquo; Volver <span class="d-none d-sm-inline">a la portada</span>
      </a>
      <a href="/">
        <img  :src="idDiario == 12 ? require(`@/assets/image/${idDiario}.png`) : require(`@/assets/image/${idDiario}.svg`)" alt="" />
      </a>
    </header>
    <section-1 />
    <section-2 />
    <section-4 />
    <section-3 />
    <footer class="app-footer">
      <p class="app-footer__text-staff mb-0">Análisis de datos: Francisco Ahumada • Diseño: Miguel Nangari • Desarrollo: Freddy Palencia </p>
    </footer>
  </div>
</template>
<script>
import { auth } from '@/services'
export default {
  name: 'home',
  data() {
    return {
      idDiario: window.app.idDiario,
    }
  },

  mounted() {
    auth.init(this);
  }
}
</script>
<style lang="scss">
  @import './src/styles/vendor.scss';
  @import './src/styles/main.scss';
  @import url('https://fonts.googleapis.com/css?family=Noticia+Text:400,400i,700,700i&display=swap');

body {
  overflow-x: hidden;
}

.app-footer {
  background-color: #1D3557;
  color: #fff;
  padding: 1rem;
  text-align: right;

  &__text-staff {
    font-size: 0.7rem;

    @include media-breakpoint-up(md) { font-size: 1rem; }
  }
  p {
    b {
      color: #fff;
    }
  }
}
</style>
